import { BoxOfferInvitationCoupon } from "@modules/boxOffer/gateway/boxOfferDto"
import { CouponInputFormik, DurationType } from "@modules/boxSubscription/formik/boxSubscriptionFormik"
import { CouponEntity } from "@modules/common/couponObject/entities/couponObjectEntity"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { formatCurrency } from "@modules/currency/currency"

export const getFormattedCouponReduction = (
  type: CouponType,
  CouponValue: number,
  locale: string,
  currency: string,
): string => {
  if (type === CouponType.DIRECT) {
    return `${formatCurrency(CouponValue, currency, locale)}`
  } else if (type === CouponType.PERCENT) {
    return `${CouponValue}%`
  } else return ``
}

/**
 * Return the price after applying the discount
 * @param coupon - Coupon with the discount
 * @param price - The price with no discount
 * @returns priceAfterDiscount - The price after applying the discount
 */
export function getPriceAfterDicount(
  coupon: CouponInputFormik | CouponEntity | BoxOfferInvitationCoupon,
  price: number,
): number {
  let priceAfterDiscount = price
  if (coupon.value <= 0) return price

  if (coupon.type === CouponType.PERCENT) {
    priceAfterDiscount = price - (price * coupon.value) / 100
  } else {
    priceAfterDiscount = price - coupon.value
  }

  return priceAfterDiscount
}

/**
 * Return the amount of discount :
 * @param coupon
 * @param price
 * @returns number
 */
export function getAmountOfDiscount(coupon: CouponInputFormik, price: number): number {
  if (coupon.type === CouponType.DIRECT) return coupon.value

  return (price * coupon.value) / 100
}

/**
 * Return the text of the duration type
 * @param coupon
 * @returns string
 */
export function getTextDurationType(coupon: CouponInputFormik): string {
  if (coupon.durationType === DurationType.UNLIMITED) return word("coupon.subscription.durationType.unlimited")
  return word("coupon.subscription.durationType.months", { count: coupon.months ?? 1 })
}
